import React, { useState } from "react";
import { Col, Modal, Spinner } from "react-bootstrap";
import Button from "../../components/shared/buttons/button";
import { CancelSvg } from "../../svgFiles/CancelSvg";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import { useUpdatePasswordMutation } from "../auth/authApi";
import toast from "react-hot-toast";
import { showToast } from "../../helpers/Utils";
import useTranslator from "../../hooks/useTranslator";

const ForgotModal = ({ show, setShow }) => {
  const { _t } = useTranslator();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [newPasswordConfirm, setnewPasswordConfirm] = useState("");
  const [updatePassword, { isLoading }] = useUpdatePasswordMutation();
  const handleClose = () => {
    setShow(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== newPasswordConfirm) {
      toast.error(
        _t("new_passwords_do_not_match", "The passwords you entered don't match. Please check and try again.")
      );
      return;
    }

    try {
      const response = await updatePassword({
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirm,
      }).unwrap();

      showToast(
        _t("password_updated_successfully", "Password updated successfully"),
        "success"
      );
      handleClose();
    } catch (error) {}
  };
  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header className="border-bottom-0 d-flex justify-content-between align-items-center">
        <h3 className="m-0">{_t("reset_password", "Reset Password")}</h3>
        <Button onClick={handleClose} icon={CancelSvg} size="small"></Button>
      </Modal.Header>
      <Modal.Body className="forgot-body">
        <Col lg={12}>
          <InputWithLabel
            label={_t("current_password", "Current Password")}
            type="password"
            name="current_password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </Col>
        <Col lg={12}>
          <InputWithLabel
            label={_t("new_password", "New Password")}
            type="password"
            name="new_password"
            value={newPassword}
            onChange={(e) => setnewPassword(e.target.value)}
          />
        </Col>
        <Col lg={12}>
          <InputWithLabel
            label={_t("confirm_password", "Confirm Password")}
            type="password"
            name="new_password_confirmation"
            value={newPasswordConfirm}
            onChange={(e) => setnewPasswordConfirm(e.target.value)}
          />
        </Col>
        <Button
          className="w-100 mb-4"
          label={_t("confirm", "Confirm")}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? <Spinner animation="border" /> : _t("delete", "Delete")}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotModal;
